import Image from "next/image";
import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import ScrollButton from "../Common/scrollButton";
import { carouralImagesProps, paraContentProps, PlanDataProps } from "@/lib/content/weddingBudgetContent/weddingBudgetPlanContent";

export const WeddingBudgetPlan = ({
    planData,
    carousalImages,
    paraContent
}: {
    planData: PlanDataProps,
    carousalImages: carouralImagesProps[],
    paraContent: (string | JSX.Element)[]
}) => {


    const [currentIndex, setCurrentIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const MAX_BOUQUET_DESKTOP = 1;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const nextBouquet = () => {
        if (isMobile) {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % carousalImages.length);
        } else {
            setCurrentIndex(
                (prevIndex) =>
                    (prevIndex + 1) % (carousalImages.length - MAX_BOUQUET_DESKTOP + 1)
            );
        }
    };

    const prevBouquet = () => {
        if (isMobile) {
            setCurrentIndex(
                (prevIndex) => (prevIndex - 1 + carousalImages.length) % carousalImages.length
            );
        } else {
            setCurrentIndex(
                (prevIndex) =>
                    (prevIndex - 1 + (carousalImages.length - MAX_BOUQUET_DESKTOP + 1)) %
                    (carousalImages.length - MAX_BOUQUET_DESKTOP + 1)
            );
        }
    };



    return (
        <div className="relative w-full  bg-secondary  " >
            <div className=" p-5 pt-16 desktop-padding relative z-10" >
                <div className="xl:grid xl:grid-cols-2  flex flex-col-reverse gap-8 " >
                    <div className="xl:w-[604px] items-start w-full flex justify-center" >
                        <div className="flex items-center gap-4 justify-center " >
                            <div className="hidden md:block" >
                                <Button
                                    className="border border-primary bg-transparent text-primary rounded-none  hover:!text-white "
                                    onClick={prevBouquet}
                                >
                                    <ChevronLeft size={48} className="h-12 w-12" />
                                </Button>

                            </div>
                            <div className="relative sm:w-[450px] w-[238px] overflow-hidden">
                                <div
                                    className="flex transition-transform duration-500 ease-in-out"
                                    style={{
                                        transform: `translateX(-${currentIndex * 100}%)`,
                                    }}
                                >
                                    {carousalImages.map((carouselImage, index) => (
                                        <div
                                            key={index}
                                            className="flex-shrink-0 w-[238px] h-[297px] sm:w-[450px] sm:h-[560px]"
                                        >
                                            <Image
                                                src={carouselImage.image}
                                                alt={carouselImage.image_alt}
                                                width={450}
                                                height={560}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>
                                    ))}
                                </div>
                                <div className="flex justify-between md:justify-center mt-2 md:mt-0  items-center " >
                                    <div className=" md:hidden" >
                                        <Button
                                            className="border border-primary bg-transparent text-primary rounded-none  hover:!text-white "
                                            onClick={prevBouquet}
                                        >
                                            <ChevronLeft size={48} className="h-12 w-12" />
                                        </Button>

                                    </div>
                                    {/* Navigation Dots */}
                                    <div className="flex gap-2 justify-center md:mt-8">
                                        {carousalImages.map((_, index) => (
                                            <div
                                                key={index}
                                                className={`w-4 h-4 rounded-full cursor-pointer ${currentIndex === index ? "bg-[#223343]" : "bg-[#99AFC4]"
                                                    }`}
                                                onClick={() => setCurrentIndex(index)}
                                            ></div>
                                        ))}
                                    </div>

                                    <div className=" md:hidden" >
                                        <Button
                                            className="border border-primary bg-transparent text-primary rounded-none  hover:!text-white "
                                            onClick={nextBouquet}
                                        >
                                            <ChevronRight size={8} className="h-2 w-2" />
                                        </Button>
                                    </div>
                                </div>

                            </div>
                            <div className="hidden md:block" >
                                <Button
                                    className="border border-primary bg-transparent text-primary rounded-none  hover:!text-white "
                                    onClick={nextBouquet}
                                >
                                    <ChevronRight size={8} className="h-2 w-2" />
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h2 className="h2 text-center xl:text-start ">{planData.h2}</h2>
                        <div className="gap-[24px] mt-7 flex flex-col" >
                            {
                                planData.pointData.map((point, index) => (
                                    <div key={index} className="flex items-center gap-9">
                                        <div>
                                            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="16.6971" cy="16.6971" r="15.6971" fill="black" stroke="white" stroke-width="2" />
                                                <path d="M6.00007 17.8947L12.2276 24L26 10" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                        <p className="body-reg">{point}</p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
                <div>
                    <h2 className="h2 sm:mt-16 mt-[30px] text-center">{planData.h3}</h2>
                    <div className="mt-[28px]">
                        {
                            paraContent.map((para, index) => (
                                <p key={index} className="mt-3 body-reg">{para}</p> // Ensure each string is rendered as a valid ReactNode
                            ))
                        }
                    </div>
                </div>

            </div>

        </div>
    );
};